import { useQuery } from "@/api/utils/useQuery"
import { QueryResult } from "@/api/utils/types"
import {
  ICommunication,
  IThrottleConfig,
} from "@/models/throttleConfig/throttleConfig.types"
import { ThrottleConfigParser } from "@/models/throttleConfig/throttleConfig.parser"
import {
  IThrottleEvent,
  ThrottleEventStatus,
} from "@/models/throttleEvent/throttleEvent.types"
import { ThrottleEventParser } from "@/models/throttleEvent/throttleEvent.parser"
import { BackofficeRestQueries } from "@/api/backofficeRest/queries"
import {
  CommunicationListResponse,
  ThrottleConfigListResponse,
  ThrottleEventListResponse,
} from "@/api/backofficeRest/generated/model"

class EmailThrottleServiceClass {
  getConfigs(): QueryResult<IThrottleConfig[]> {
    return useQuery<ThrottleConfigListResponse, IThrottleConfig[]>({
      ...BackofficeRestQueries.throttle.configs,
      placeholderData: [],
      useRawResponse: true,
      parserFn: (data) =>
        data.configs.map((config) => ThrottleConfigParser.toDomain(config)),
    })
  }

  getEvents(status?: ThrottleEventStatus): QueryResult<IThrottleEvent[]> {
    return useQuery<ThrottleEventListResponse, IThrottleEvent[]>({
      ...BackofficeRestQueries.throttle.events(status),
      placeholderData: [],
      useRawResponse: true,
      parserFn: (data) =>
        data.events.map((event) => ThrottleEventParser.toDomain(event)),
    })
  }

  getCommunications(): QueryResult<ICommunication[]> {
    return useQuery<CommunicationListResponse, ICommunication[]>({
      ...BackofficeRestQueries.throttle.communications,
      placeholderData: [],
      useRawResponse: true,
      parserFn: (data) =>
        data.communications.map((communication) => ({
          id: communication.id,
          name: communication.name,
        })),
    })
  }
}

export const EmailThrottleService = new EmailThrottleServiceClass()
